module.exports = ".demo-tab-group {\n  border: 1px solid #e8e8e8; }\n\n.demo-tab-content {\n  padding: 16px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/search/search.component.scss
// module id = ./src/app/search/search.component.scss
// module chunks = main